// extracted by mini-css-extract-plugin
export default {"teal":"mC","break":"nC","light":"oC","pipe":"pC"};
    if(module.hot) {
      // 1713809678241
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  